import React from 'react'

const ChartContainer = (props) => {

    return <div id={props.id} className={`p-col-12  ${props.type ? `chart-container-${props.type}` : `chart-container`} `}>
        {props.children}
    </div>
}
export default ChartContainer;
